<template>
    <v-card outlined>
        <v-container>
            <v-data-table
            dense
            :items-per-page="15"
            :headers="headers"
            :items="confirmed"
            hide-default-footer
            >
                <template v-slot:item.name="{ item }">
                    <div v-html="urlTNSObject(item.name)"></div>
                </template>
                <template v-slot:item.disc_internal_name="{ item }">
                    <div v-html="urlZTFObject(item.disc_internal_name)"></div>
                </template>
            </v-data-table>
        </v-container>
    </v-card>
</template>
<script>
export default {
    props: ["confirmed", "msg"],
    name: "TableTNS",
    data(){
        return {
            headers: [
                { text: 'Name', value: 'name' },
                { text: 'Obj. Type', value: 'obj_type' },
                { text: 'Disc. date', value: 'discovery_date_ut' },
                { text: 'Disc. internal name', value: 'disc_internal_name'}
            ]
        }
    },
    methods: {
        urlZTFObject(candidate) {
            return `<a href="https://alerce.online/object/${candidate}" target="_blank">${candidate}</a>`;
        },
        urlTNSObject(candidate) {
            return `<a href="https://wis-tns.weizmann.ac.il/object/${candidate}" target="_blank">${candidate}</a>`;
        },
    }
}
</script>